import React, { FunctionComponent, useEffect } from 'react'
import { CountdownTimer, Loader, useVerifyingCountdown } from '@afterpaytouch/core'
import { useConsumerSizes } from '../../../utils/responsive'
import { useTranslation } from 'next-i18next'
import { useAppRouter, useConsumerCountry, useConsumerName, useConsumerEmail, useConsumerSelector, showToast, useAppDispatch } from '../../../state'
import { Route } from '../../../config/router'
import { BIOMETRIC_VERIFYING_DEFAULT_WAIT_TIME, BIOMETRIC_VERIFYING_TIME_OUT, isCountrySkipCreateCheck } from '../../../model/identity'
import { ProfileCard } from '../../ProfileCard'
import { BiometricHardIdCheckHookStatus, useBiometricHardIdCheck, useIdFlowErrorHandler } from '../hooks'

export const VerifyingBiometric: FunctionComponent = () => {
  const router = useAppRouter()
  const country = useConsumerCountry()
  const { textSize } = useConsumerSizes()
  const consumerName = useConsumerName()
  const consumerEmail = useConsumerEmail() ?? ''
  const { biometricApplicantId, skipBiometricCheck } = useConsumerSelector() ?? {}
  const { t } = useTranslation()
  const { handleError } = useIdFlowErrorHandler()
  const isSkipCreateCheck = isCountrySkipCreateCheck(country)
  const dispatch = useAppDispatch()
  const { status } = useBiometricHardIdCheck(biometricApplicantId, skipBiometricCheck)

  const testNameSpace = 'biometric-verifying'
  const tNameSpace = 'verifyIdentity:verifying'

  const { isCountingDown: maxTimeoutCountingDown } = useVerifyingCountdown(BIOMETRIC_VERIFYING_TIME_OUT)

  useEffect(() => {
    if (!maxTimeoutCountingDown) {
      handleError()
    }
  }, [maxTimeoutCountingDown])

  useEffect(() => {
    if (status === BiometricHardIdCheckHookStatus.INITIAL) {
      return
    }
    switch (status) {
      case BiometricHardIdCheckHookStatus.FAILED:
        router.push(`${Route.TERMINAL_ERROR}/identityVerificationFailedManual`)
        break
      case BiometricHardIdCheckHookStatus.INVALID_APPLICANT_ID:
        handleError()
        break
      case BiometricHardIdCheckHookStatus.VERIFIED:
        dispatch(showToast({ toastType: 'accountVerified' }))
        router.push(Route.HOME)
        break
      default:
        router.push(Route.HOME)
        break
    }
  }, [status])

  return (
    <>
      <div className='mb-4 mt-4'>
        <ProfileCard consumerName={consumerName} consumerEmail={consumerEmail} />
      </div>
      {isSkipCreateCheck ? (
        <Loader testNameSpace={testNameSpace} text={t(`${tNameSpace}:loader`)} />
      ) : (
        <CountdownTimer
          loaderText={'verifyIdentity:verifying:loader'}
          loaderTextExtended={'verifyIdentity:verifying:loaderExtended'}
          loaderTimeSecondsAndMinutes={'verifyIdentity:verifying:loaderTimer:infoSecondsAndMinutes'}
          loaderTimeSeconds={'verifyIdentity:verifying:loaderTimer:infoSeconds'}
          loaderTimeExtended={'verifyIdentity:verifying:loaderExtendedInfo'}
          time={BIOMETRIC_VERIFYING_DEFAULT_WAIT_TIME}
          testNameSpace={testNameSpace}
          t={t}
          textSize={textSize}
        />
      )}
    </>
  )
}
